module.exports = __webpack_public_path__ + "assets-cabinet/img/stage-checkmark-icon.cee7d2ba.svg";